/**
 * Custom hook for auto-saving workflow
 * 
 * @fileoverview Auto-save hook for workflow builder
 */

import { useEffect } from 'react';
import { useDebounce } from './useDebounce';
import { useWorkflowStore } from '../store/workflowStore';
import { supabase } from '../lib/supabase';
import toast from 'react-hot-toast';

/**
 * Hook for auto-saving workflow
 * @param {string} workflowId - Workflow ID
 * @param {Object[]} nodes - Workflow nodes
 * @param {Object[]} edges - Workflow edges
 */
export function useAutoSave(workflowId, nodes, edges) {
  const debouncedNodes = useDebounce(nodes, 2000);
  const debouncedEdges = useDebounce(edges, 2000);

  useEffect(() => {
    if (!workflowId || (debouncedNodes.length === 0 && debouncedEdges.length === 0)) {
      return;
    }

    const saveWorkflow = async () => {
      try {
        const { error } = await supabase
          .from('developer_workflows')
          .update({
            workflow_data: {
              nodes: debouncedNodes,
              edges: debouncedEdges,
              viewport: { x: 0, y: 0, zoom: 1 },
            },
            updated_at: new Date().toISOString(),
          })
          .eq('id', workflowId);

        if (error) throw error;

        // Silent save - no toast notification
      } catch (error) {
        console.error('Auto-save failed:', error);
        // Don't show toast on auto-save failure to avoid spam
      }
    };

    saveWorkflow();
  }, [workflowId, debouncedNodes, debouncedEdges]);
}

